import { Container, Typography } from '@mui/material'
import React from 'react'
import { fontTitle } from '../MainPage/styles'

export default function Cookies() {
    return (
        <Container maxWidth='md' sx={{ py: '120px' }}>
            <Typography sx={{ ...fontTitle, pb: '50px' }}>Zásady používání souborů cookies</Typography>
            <Typography sx={{ textAlign: 'left' }}>
                <br />
                Tyto webové stránky provozované společností Profaktura s.r.o. (dále jen „my“) používají soubory cookies. Níže se dozvíte, co to cookies jsou, jaké z nich používáme a jak je můžete spravovat.
                <br /><br />
                <b>1. Co jsou to cookies?</b><br /><br />
                Cookies jsou malé textové soubory, které se uloží ve vašem prohlížeči, když navštívíte náš web. Pomáhají nám pamatovat si vaše preference a pochopit, jak náš web používáte, abychom ho mohli neustále zlepšovat.
                <br /><br />
                <b>2. Jaké cookies používáme?</b><br /><br />
                Na našem webu používáme pouze dva základní typy cookies:
                <br /><br />
                Nezbytné (technické) cookies: Tyto cookies jsou nutné pro to, aby náš web vůbec správně fungoval a zobrazoval se vám tak, jak má. K jejich použití nepotřebujeme váš souhlas.
                <br /><br />
                Analytické cookies (Google Analytics): Abychom věděli, kolik lidí náš web navštěvuje a jaké služby je nejvíce zajímají, využíváme službu Google Analytics (poskytovanou společností Google Ireland Limited). Tyto cookies shromažďují informace zcela anonymně – nevíme, kdo přesně jste, vidíme pouze obecné statistiky návštěvnosti. K použití těchto cookies od vás potřebujeme souhlas (který můžete udělit v cookie liště při příchodu na web).
                <br /><br />
                <b>3. Jak Google používá vaše data?</b><br /><br />
                Informace o tom, jak společnost Google zpracovává data získaná prostřednictvím služby Google Analytics, najdete v [podmínkách ochrany soukromí společnosti Google].
                <br /><br />
                <b>4. Jak můžete cookies spravovat nebo smazat?</b><br /><br />
                Používání cookies můžete kdykoliv odmítnout nebo upravit přímo v nastavení svého internetového prohlížeče (Chrome, Safari, Firefox, Edge atd.). V prohlížeči si můžete existující cookies smazat nebo nastavit, aby se vůbec neukládaly. Upozorňujeme však, že zablokování technických cookies může omezit správné fungování některých prvků na webu.
                <br /><br />
                Pokud máte k používání cookies jakékoliv dotazy, kontaktujte nás na e-mailu: info@cistidoma.cz.
            </Typography>
        </Container>
    )
}
